import React, { useMemo, useState } from 'react'
import SydTabs from '../../../commonDesign/SydTabs'
import { useCheckPolicy } from '../../../../hooks'
import BatchListTable from './BatchListTable'
import { BatchCreateAction } from './BatchCreateAction'

export const UserBatchesAdmin = () => {
  const userCanViewCreation = useCheckPolicy('admin_view_users_bulkcreate')
  const userCanViewInvite = useCheckPolicy('admin_view_users_bulkinvite')

  const tabs = useMemo(() => ([
    { key: 'bulk-create-users', label: 'Bulk User Creation', visible: userCanViewCreation },
    { key: 'bulk-invite-users', label: 'Bulk User Invitation', visible: userCanViewInvite }
  ]), [userCanViewCreation, userCanViewInvite])

  const visibleTabs = useMemo(() => tabs.filter(tab => tab.visible), [tabs])
  const [currentTab, setCurrentTab] = useState(visibleTabs?.[0]?.value)

  return (
    <div className='p-1'>
      <div>
        <SydTabs.Group
          tabOptions={visibleTabs.reduce((acc, tab) => ({ ...acc, [tab.key]: tab.label }), {})}
          onChange={(val) => setCurrentTab(val)}
          defaultValue={currentTab}
          key='user_batches_admin'
        >
          <SydTabs.Links
            rightAdornment={(
              <BatchCreateAction />
            )}
          />
        </SydTabs.Group>
      </div>

      {currentTab && (
        <BatchListTable batchType={currentTab} />
      )}
    </div>
  )
}
